// extracted by mini-css-extract-plugin
export var container = "MediaLinkTemplate-module--container--+FfpL";
export var logo = "MediaLinkTemplate-module--logo--AxKds";
export var date = "MediaLinkTemplate-module--date--UNJSp";